import { LinkItem, Maybe } from '~/jobiqo/types/types';
import Link from '~/jobiqo/components/Link';
import LinkButton from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import styles from './RowButtons.module.scss';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { JustifyContentProps } from '~/vcl/theme/layout/itemsLayout';
import { cva } from 'class-variance-authority';
import NextLink from 'next/link';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface RowButtonsProps {
  /**
   * The first button to be displayed.
   */
  button1?: Maybe<LinkItem>;
  /**
   * The second button to be displayed.
   */
  button2?: Maybe<LinkItem>;
  /**
   * The button styles (color).
   */
  buttonStyle: any;
  /**
   * If the buttons should be centered or not.
   *
   * @default 'center'
   */
  justifyContent?: JustifyContentProps | JustifyContentProps[] | undefined;
}

const flexItem = cva([styles.item], {
  variants: {
    vertical: {
      true: styles.vertical,
    },
  },
});
const flexItems = cva([], {
  variants: {
    verticalItems: {
      true: styles.verticalItems,
    },
  },
});

export function RowButtons({
  button1,
  button2,
  buttonStyle,
  justifyContent = 'center',
}: RowButtonsProps) {
  const { APP } = useFrontendConfig();

  return (
    <FlexItems
      gap={4}
      justifyContent={justifyContent}
      className={flexItems({
        verticalItems: APP.LANDING_PAGE_BUTTONS_VERTICAL_MOBILE,
      })}
    >
      {button1 && button1?.url && button1?.text && (
        <div
          className={flexItem({
            vertical: APP.LANDING_PAGE_BUTTONS_VERTICAL_MOBILE,
          })}
        >
          <Link asChild prefetch={false}>
            <LinkButton
              linkElement={NextLink}
              {...getFormattedPageLink(button1?.url)}
              buttonStyle={buttonStyle}
            >
              {button1?.text}
            </LinkButton>
          </Link>
        </div>
      )}
      {button2 && button2?.url && button2?.text && (
        <div
          className={flexItem({
            vertical: APP.LANDING_PAGE_BUTTONS_VERTICAL_MOBILE,
          })}
        >
          <Link asChild prefetch={false}>
            <LinkButton
              linkElement={NextLink}
              {...getFormattedPageLink(button2?.url)}
              buttonStyle={buttonStyle}
              bordered={true}
            >
              {button2?.text}
            </LinkButton>
          </Link>
        </div>
      )}
    </FlexItems>
  );
}
